import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';

import { gqlClient } from '@/utilities/graphQLClient';

import {
  WATCHLIST_FRAGMENT,
  WATCHLIST_ITEM_FRAGMENT,
  WATCHLIST_NARRATIVE_FAIR_VALUE_FRAGMENT,
} from '@/hooks/useWatchlist';

const QUERY = gql(
  `
  mutation createWatchlist($name: String!) {
    createWatchlist(name: $name) {
      ...watchlistFields
      # June Hackathon 2025
      publicToken
      items {
        ...watchlistItemFields
        ...narrativeFairValueFields
      }
    }
  }

`,
  [
    WATCHLIST_FRAGMENT,
    WATCHLIST_ITEM_FRAGMENT,
    WATCHLIST_NARRATIVE_FAIR_VALUE_FRAGMENT,
  ]
);

type Args = VariablesOf<typeof QUERY>;

export const mutationFn = async ({ name }: Args) => {
  const response = await gqlClient.request(QUERY, {
    name,
  });

  if ('createWatchlist' in response) {
    return response.createWatchlist;
  }
};
